import Checkboxes from '../../inputs/Checkboxes/Checkboxes/Checkboxes';
import Radios from '../../inputs/Radios/Radios/Radios';

import classes from './FilterOrder.module.scss';

const FilterOrder = ({
  orderOptions,
  orderValue,
  changeOrderValueHandler,
  filterOptions,
  filterValues,
  filterOptionsGrouped,
  filterGroupedValues,
  changeFilterValues,
  changeFilterGroupedValues
}) => {
  // const orderOptionsFunctions = (orderOptions || []).reduce((prev, { key, func }) => {
  //   prev[key] = func;
  //   return prev;
  // }, {});

  const filterFunctions = (filterOptions || []).reduce((prev, { key, func }) => {
    prev[key] = func;
    return prev;
  }, {});

  return (
    <>
      {/* <div className={classes.box}>
        <span className={`semibold-16 ${classes.subtitle}`}>Ordenar por</span>
        <Radios
          className={classes.options}
          options={orderOptions}
          value={orderValue}
          onChange={newValue => changeOrderValueHandler(newValue, orderOptionsFunctions[newValue])}
        />
      </div> */}
      <div className={classes.box}>
        {(filterOptions || filterOptionsGrouped) && <span className={`semibold-16 ${classes.subtitle}`}>Filtrar por</span>}

        {filterOptions && (
          <Checkboxes
            className={classes.options}
            options={filterOptions}
            values={filterValues}
            onChangeKeys={filterValues => changeFilterValues(filterValues, filterFunctions)}
          />
        )}
        {filterOptionsGrouped &&
          filterOptionsGrouped.map(({ key, label, options }) => (
            <div key={key} className={classes['filter-grouped']}>
              <span className={`semibold-16 ${classes.subtitle}`}>{label}</span>
              <Radios
                className={classes.options}
                options={[{ key: 'all', label: 'Todos' }, ...options]}
                value={filterGroupedValues[key]}
                onChange={newValue => changeFilterGroupedValues(key, newValue)}
                name={label}
              />
            </div>
          ))}
      </div>
    </>
  );
};

export default FilterOrder;
